<script lang="ts" setup>
import {ProjectNavigationItem} from "@/types";
import {useDisplay} from "vuetify";
import NotificationSidebar from "@/Pages/notifications/components/NotificationSidebar.vue";

const { mdAndUp } = useDisplay()

const items: Array<ProjectNavigationItem> = [
    {
        route: 'notifications.index',
        label: 'All',
        icon: 'mdi-message-outline',
        roles: [],
    },
    {
        route: 'unread_notifications.index',
        label: 'Unread',
        icon: 'mdi-message-badge-outline',
        roles: [],
    },
]
</script>

<template>
    <v-navigation-drawer
        class="pl-5 border-e-0 pt-5 pr-2"
        mobile-breakpoint="sm"
        :width="mdAndUp ? 320 : undefined"
    >
        <notification-sidebar
            :items="items"
        />
    </v-navigation-drawer>
    <v-row class="fill-height mx-3 mx-md-0">
        <v-col
            cols="12"
            lg="10"
        >
            <notification-sidebar
                class="d-block d-sm-none"
                :items="items"
            />
            <slot />
        </v-col>
    </v-row>
</template>

<style scoped>
</style>
